require('./globals.css')